/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { GATEWAY_URL } from '../../shared/app-config';
import { environment } from '../../../environments/environment';
import { UserMatrix } from './data/userMatrix.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private httpClientByPass: HttpClient;
  private readonly GATEWAY_URL: string = GATEWAY_URL;

  constructor(
    private router: Router,
    private handler: HttpBackend) {
    this.httpClientByPass = new HttpClient(handler);
  }

  public authenticate(username: string, password: string): Observable<any> {
    const loginVM = { username, password, rememberMe: false };

    return new Observable<any>((subscriber: Subscriber<any>) => {
      this.httpClientByPass.post(`${environment.gatewayBase}/${environment.cella.endpoints.authenticate}`,
        loginVM)
        .subscribe((respAuthenticate: any) => {
          window.localStorage.setItem('token', respAuthenticate.id_token);
          this.getAccount().subscribe((respAccount: any) => {
            window.localStorage.setItem('profile', JSON.stringify(respAccount));
            this.getUserMatrix(respAccount.id)
              .subscribe(userMatrix => window.localStorage.setItem('userMatrix', JSON.stringify(userMatrix)));
            subscriber.next(respAccount);
            subscriber.complete();
          }
          );
        }, (error) => {
          if (error.status === 401 || error.status === 400) {
            if (error.error.AuthenticationException === 'User is disabled') {
              subscriber.next({ ERROR: 'User is disabled.' });
              subscriber.complete();
            } else {
              subscriber.next({ ERROR: 'Incorrect credentials.' });
              subscriber.complete();
            }
          } else if (error.status === 403) {
            subscriber.next({ ERROR: 'Incorrect credentials.' });
            subscriber.complete();
          } else if (error.status === 503) {
            subscriber.next({ ERROR: 'Service is unavailable.' });
            subscriber.complete();
          } else {
            subscriber.next({ ERROR: 'No internet connection.' });
            subscriber.complete();
          }
        });
    });
  }

  public getAccount(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + window.localStorage.getItem('token')
    });
    return this.httpClientByPass.get(`${environment.gatewayBase}/api/account`, { headers });
  }


  getUserMatrix(userId: number): Observable<UserMatrix> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + window.localStorage.getItem('token')
    });
    return this.httpClientByPass.get<UserMatrix>(`${environment.gatewayBase}/api/users/matrix/${userId}`, { headers });

  }

  logout(): void {
  this.router.navigate(['/login']);
  }

  tokenExpired(): boolean {
    const token = window.localStorage.getItem('token');
    if (token) {
      const valid: boolean = new JwtHelperService().isTokenExpired(token);
      return valid;
    }
    return false;
  }

  isLoggedIn(): boolean {
    return window.localStorage.getItem('profile') ? true : false;
  }
}
